import React from 'react'
import '../../styles/newCareer.css'
import {
    Box, Grid,
    Typography
} from '@mui/material'
// import checkIcon from '../../images/career/checkIcon.png'
import formIcon from '../../images/career/form.png'
import jobIcon from '../../images/career/job-search.png'
import presentationcon from '../../images/career/presentation.png'
import careerIcon from '../../images/career/career-path.png'
import CheckIcon from '@mui/icons-material/Check';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

export default function NewCareer() {
    return (
        <>
            <section style={{ width: '100%', overflow: 'hidden' }}>
                <Box sx={{ padding: '0 4% 0 7%', my: '5%', }}>
                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', }}>
                        <Grid container spacing={2}>
                            <Grid item md={6} sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                                <Typography
                                    sx={{
                                        color: "#3665D0"
                                    }}
                                    className="subHeading2Mid"
                                >Let’s Start</Typography>
                                <Typography sx={{
                                    fontFamily: "Inter",
                                    fontWeight: 600,
                                    fontSize: "45px",
                                    lineHeight: "50px",
                                    my: 2

                                }} className='bannerTextMid'>Your Step to a new career</Typography>
                                <Box className='newCareer-div-1'>
                                    <Box display={{ display: 'flex', flexDirection: 'column' }}>
                                        <Box className='newCareer-div-1-span1' sx={{ display: 'flex', gap: 2, alignItems: 'center', }} >
                                            <Box > <CheckCircleRoundedIcon sx={{fontSize:'30px', color:'#2544EE'}} /></Box>
                                            <span className='heading2mid newCareer-div-1-span'>Learn faster with us</span>
                                        </Box>
                                        <Box className='newCareer-div-1-span1' sx={{ display: 'flex', gap: 2, alignItems: 'center', }}>
                                            <Box>  <CheckCircleRoundedIcon sx={{fontSize:'30px', color:'#2544EE'}} /></Box>
                                            <span className='heading2mid newCareer-div-1-span'>Interview preparation</span>
                                        </Box>
                                    </Box>
                                    <Box display={{ display: 'flex', flexDirection: 'column' }}>
                                        <Box className='newCareer-div-1-span1' sx={{ display: 'flex', gap: 2, alignItems: 'center', }}>
                                            <Box>  <CheckCircleRoundedIcon sx={{fontSize:'30px', color:'#2544EE'}} /></Box>
                                            <span className='heading2mid newCareer-div-1-span'>Coach expertise</span>
                                        </Box>
                                        <Box className='newCareer-div-1-span1' sx={{ display: 'flex', gap: 2, alignItems: 'center', }}>
                                            <Box>  <CheckCircleRoundedIcon sx={{fontSize:'30px', color:'#2544EE'}} /></Box>
                                            <span className='heading2mid newCareer-div-1-span'>Top rated company employers</span>
                                        </Box>
                                    </Box>
                                </Box>



                            </Grid>
                            <Grid item md={6}>

                                <Grid container spacing={4}>
                                    <Grid item xs={12} sm={6}  >

                                        <Box className='newCareer-col-3'  >
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                <Box sx={{ border: '1px solid rgba(210, 210, 210, 0.3)', borderRadius: '50%' }}>
                                                    <img src={formIcon} alt='icon' className='newCareer-col_img' />
                                                </Box>
                                                <span className='subHeading2Bold'>Register Your Account</span>
                                            </Box>
                                            <Box>
                                                <span className='newCareer-col-span-2 text1Mid'>
                                                    You need to create an account to get the best and preferred job.You need to create an account to get the best and preferred job.
                                                </span>
                                            </Box>

                                        </Box>


                                    </Grid>
                                    <Grid item xs={12} sm={6} >


                                        <Box className='newCareer-col-3'>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                <Box sx={{ border: '1px solid rgba(210, 210, 210, 0.3)', borderRadius: '50%' }}>
                                                    <img src={jobIcon} alt='icon' className='newCareer-col_img' />
                                                </Box>
                                                <span className='subHeading2Bold'>Find Your Dream Job</span>
                                            </Box>
                                            <Box>
                                                <span className='newCareer-col-span-2 text1Mid'>
                                                    You need to create an account to get the best and preferred job.You need to create an account to get the best and preferred job.
                                                </span>
                                            </Box>
                                        </Box>



                                    </Grid>
                                    <Grid item xs={12} sm={6} >


                                        <Box className='newCareer-col-3' >
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                <Box sx={{ border: '1px solid rgba(210, 210, 210, 0.3)', borderRadius: '50%' }}>
                                                    <img src={presentationcon} alt='icon' className='newCareer-col_img' />
                                                </Box>
                                                <span className='subHeading2Bold'>Get Training From Best Coaches </span>
                                            </Box>
                                            <Box>
                                                <span className='newCareer-col-span-2 text1Mid'>
                                                    You need to create an account to get the best and preferred job.You need to create an account to get the best and preferred job.
                                                </span>
                                            </Box>
                                        </Box>



                                    </Grid>
                                    <Grid item xs={12} sm={6} >
                                        <Box className='newCareer-col-3'>

                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                <Box sx={{ border: '1px solid rgba(210, 210, 210, 0.3)', borderRadius: '50%' }}>
                                                    <img src={careerIcon} alt='icon' className='newCareer-col_img' />
                                                </Box>
                                                <span className='subHeading2Bold'>Give Your Career A Right Direction</span>
                                            </Box>
                                            <Box>
                                                <span className='newCareer-col-span-2 text1Mid'>
                                                    You need to create an account to get the best and preferred job.You need to create an account to get the best and preferred job.
                                                </span>
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </section>
        </>
    )
}
